module.exports = __webpack_public_path__ + "img/logo-with-text-black.45b959db.svg";